import { render, staticRenderFns } from "./MicrophoneTranscription.vue?vue&type=template&id=41457c2b&scoped=true"
import script from "./MicrophoneTranscription.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrophoneTranscription.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrophoneTranscription.vue?vue&type=style&index=0&id=41457c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41457c2b",
  null
  
)

export default component.exports